import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe, NgStyle } from '@angular/common';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { ArticlesService } from '../../services/articles.service';
import { QuillModule } from 'ngx-quill';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss'],
  imports: [AsyncPipe, NgStyle, QuillModule]
})
export class BlogPageComponent {
  private route = inject(ActivatedRoute);
  private articleService = inject(ArticlesService);
  private storage = inject(AngularFireStorage);
  private destroyRef = inject(DestroyRef);

  image;
  post;

  constructor() {
    this.getBlogPost();
  }

  getBlogPost() {
    const id = this.route.snapshot.paramMap.get('id');
    this.articleService.getBlogPost(id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.post = data;
      this.getImage();
    });
  }

  getImage() {
    if (this.post?.attributes?.image != null) {
      this.image = this.storage.ref(this.post.attributes.image).getDownloadURL();
    } else if (this.post?.attributes?.fileLink != null) {
      this.image = this.post.attributes.fileLink;
    }
  }
}
